import React, { Component } from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsListInsightsBlock extends Component {
  createdAt = new Date();

  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">List insights</div>
          <div className="text">Returns a paginated list of insights for your company.</div>
          <APIDocsTable
            title="Arguments"
            rows={[
              {
                heading: 'apiKey',
                subheading: 'string',
                description: 'Your secret API key.',
              },
              {
                heading: 'cursor',
                subheading: 'string (optional)',
                description:
                  'A pagination cursor returned from a previous request. Use it to fetch the next page of results.',
              },
              {
                heading: 'ideaID',
                subheading: 'string (optional)',
                description:
                  'If specified, will only fetch insights associated with the idea with this id.',
              },
              {
                heading: 'limit',
                subheading: 'number (optional)',
                description:
                  'The number of insights to fetch. Defaults to 50 if not specified. Maximum is 100.',
              },
            ]}
          />
          <div className="subheading">Returns</div>
          <div className="text">
            A dictionary with an "items" array of insight objects, a "hasNextPage" boolean
            indicating if more results are available, and a "cursor" string to fetch the next page
            when hasNextPage is true.
          </div>
        </div>
        <div>
          <div className="text">Endpoint</div>
          <Highlight lang="http">https://canny.io/api/v1/insights/list</Highlight>
          <APIDocsMethod />
          <APIDocsCurl
            path="https://canny.io/api/v1/insights/list"
            body={`\\
    -d apiKey=YOUR_API_KEY \\
    -d limit=10`}
          />
          <div className="text">Example Response</div>
          <Highlight lang="json">
            {`{
  "cursor": "eyJhZnRlciI6eyJfaWQiOiI1NTNjM2VmOGI4Y2RjZD...",
  "hasNextPage": true,
  "items": [{
    "id": "553c3ef8b8cdcd1501ba1235",
    "author": {
      "id": "553c3ef8b8cdcd1501ba1236",
      "created": "${this.createdAt.toISOString()}",
      "email": "john@example.com",
      "isAdmin": false,
      "name": "John Doe",
      "url": "https://your-company.canny.io/admin/users/john-doe",
      "userID": "1234"
    },
    "company": {
      "monthlySpend": 1000,
      "name": "Company Name",
      "id": "1234567890",
      "urlName": "company-name"
    },
    "created": "${this.createdAt.toISOString()}",
    "priority": "high",
    "source": {
      "name": "ui",
      "type": "manual"
    },
    "url": null,
    "users": [{
      "id": "553c3ef8b8cdcd1501ba123a",
      "created": "${this.createdAt.toISOString()}",
      "email": "john@example.com",
      "isAdmin": false,
      "name": "John Doe",
      "url": "https://your-company.canny.io/admin/users/john-doe",
      "userID": "1234"
    }],
    "value": "This is an important insight about the feature."
  }]
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
